import * as React from 'react';
import { Instance } from 'mobx-state-tree';
import { PharmacyStore } from '../../store';
import { inject, observer } from 'mobx-react';

interface DutyCalendarProps {
  PharmacyStore?: Instance<typeof PharmacyStore>;
}

interface DutyCalendarState {
  view: 'map' | 'grid' | 'calendar';
}

@inject('PharmacyStore')
@observer
class DutyCalendar extends React.Component<DutyCalendarProps, DutyCalendarState> {
  render() {
    return <>Univeral Calendar</>;
  }
}

export default DutyCalendar;
